import React from 'react';
import CopyToClipboard from '../../CopyToClipboard';
import Button from '../../Button';

const isCopyAction = (action: string) => action.includes('pageAction=copy');

type ButtonProps = React.ComponentProps<typeof Button>;

interface ResourceActionButtonProps {
  actionLink: string;
  actionLabel: string;
  buttonProps: ButtonProps;
}

export const ResourceActionButton: React.FC<ResourceActionButtonProps> = ({
  actionLink,
  actionLabel,
  buttonProps,
}) =>
  isCopyAction(actionLink || '') ? (
    <CopyToClipboard>
      {({ copy }) => (
        <Button {...buttonProps} onClick={() => copy(window.location.href)}>
          {actionLabel}
        </Button>
      )}
    </CopyToClipboard>
  ) : (
    <Button {...buttonProps}>{actionLabel}</Button>
  );
